import {
  ApduRequest,
  TapApduRequest,
  TapRequestFrame,
} from '@iotize/tap/client/api';

import { TapRequestFrameConverter } from '../generated/converter';

export function createApduFromTapRequest(
  request: TapRequestFrame,
): ApduRequest {
  const data = new TapRequestFrameConverter().encode(request); // TODO
  // TODO check if size > 255 ?
  let ins: number;
  switch (request.header.methodType) {
    case TapRequestFrame.MethodType.GET:
      ins = TapApduRequest.MethodType.GET;
      break;
    case TapRequestFrame.MethodType.PUT:
    case TapRequestFrame.MethodType.POST:
      ins = TapApduRequest.MethodType.PUT_OR_POST;
      break;
    default:
      throw new Error(
        `Internal error: request type "${request.header.methodType}" is invalid`,
      );
  }
  return {
    header: {
      cla: TapApduRequest.Default.CLA,
      ins,
      p1: 0,
      p2: 0,
      lc: data.length,
    },
    data,
  };
}
